import { ref } from 'vue';

const getExternalTimesWithoutOut = () => {
    const externalTimeWithoutOut_error = ref(null);
    const externalTimesWithoutOut = ref(null);

    const loadExternalTimesWithoutOut = async (monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others', monitor_others]);
        params.push(['view_locations', view_locations]);
        params.push(['type', 'withoutOutTime'])

        try {
            let data = await fetch("/api/externaltimes?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            externalTimesWithoutOut.value = await data.json();
        } catch (err) {
            externalTimeWithoutOut_error.value = err.message;
        }
    };

    const setExternalOuttime = async (externaltime) => {
        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        try {
            const response = await fetch('/api/getemployeeday?id=' + externaltime.id + '&employee_id=' + externaltime.employee_id,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            var employeeDay = null;
            if (!response.ok) {
                console.log("error get employeeday", response.body);
            } else {
                var employeeDay = await response.json();
            }
            console.log('employeeDay', employeeDay);
            //            employeeDay = JSON.parse(employeeDay);

            Date.prototype.toJSON = function () {
                const hoursDiff = this.getHours() - this.getTimezoneOffset() / 60;
                this.setHours(hoursDiff);
                return this.toISOString();
            };


            console.log('externaltime', externaltime);

            if (externaltime.in_at) {
                if (employeeDay) {
                    var employeedayout = new Date(employeeDay.end_at);
                    var externaltimein = new Date(employeeDay.origin_in_at);

                    console.log('employeedayout', employeedayout);
                    console.log('externaltimein', externaltimein);

                    externaltime.out_at = employeedayout;
                    if (externaltimein > employeedayout) {
                        externaltime.out_at = externaltimein.toISOString();
                    }
                } else {
                    externaltime.out_at = new Date(externaltime.in_at);
                    externaltime.out_at.setTime(externaltime.out_at.getTime() + 1000);
                    externaltime.out_at = externaltime.out_at.toISOString();
                }
            }

            const requestOptionsExternalTime = {
                method: 'PUT',
                headers: {
                    'X-XSRF-TOKEN': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(externaltime)
            };

            try {
                const responseExternalTime = await fetch('/api/externaltimes/' + externaltime.id, requestOptionsExternalTime);
                if (!responseExternalTime.ok) {
                    console.log(responseExternalTime.body);
                }
            } catch (err) {
                externalTimeWithoutOut_error.value = err.message;
                console.log(err.message);
            }
        } catch (err) {
            externalTimeWithoutOut_error.value = err.message;
            console.log(err.message);
        }
    };

    return { externalTimesWithoutOut, externalTimeWithoutOut_error, loadExternalTimesWithoutOut, setExternalOuttime };
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getExternalTimesWithoutOut;
